<template>
    <div class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
                <!-- Col Header -->
                <div class="text-center mb-3">
                    <feather-icon icon="MaximizeIcon" class="mr-2 mb-1" svgClasses="w-6 h-6" />
                    <span class="leading-none font-medium fsz">{{ $t('menuCustomer.faceData') }}</span>
                </div>
                <div class="vx-row">
                    <vue-upload-multiple-image class="m-auto" @upload-success="uploadImageSuccess"
                                               @before-remove="beforeRemove" @edit-image="editImage" @data-change="dataChange"
                                               :data-images="images">
                    </vue-upload-multiple-image>
                </div>
            </div>

            <div class="vx-col md:w-1/2 w-full" v-if="customerInfo.card">
                <!-- Col Header -->
                <div class="flex mb-3 items-end ml-12">
                    <vs-icon icon="credit_card" size="small mr-2"></vs-icon>
                    <!-- <vs-icon icon="line_end_diamond" size="small" color="red"></vs-icon> -->
                    <span class="leading-none font-medium fsz">Thẻ thành viên</span>
                </div>
                <div class="vx-row">
                    <div class="vx-col">
                        <div class="vx-card membership_card_silver_rank">
                            <div class="p-8 h-full align-middle">
                                <div class="vx-row">
                                    <div class="vx-col w-full">
                                        <span class="text-xl text-primary font-bold">{{ customerInfo.cardNumber }}</span>
                                    </div>
                                </div>
                                <div class="vx-row mt-2">
                                    <div class="vx-col md:w-1/2 w-full">
                                        <span>Ngày tạo:</span>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full">
                                        <span>{{ customerInfo.createdDateFormat }}</span>
                                    </div>
                                </div>
                                <div class="vx-row mt-2">
                                    <div class="vx-col w-full">
                                        <span class="text-xl text-primary font-bold">{{ customerInfo.fullNameUpperCase
                                            }}</span>
                                    </div>
                                </div>
                                <div class="vx-row mt-2">
                                    <div class="vx-col md:w-1/2 w-full">
                                        <span>Điểm thưởng:</span>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full">
                                        <span>{{ customerInfo.points }}</span>
                                    </div>
                                </div>
                                <!-- <span class="text-xl text-primary font-bold">{{ customerInfo.cardNumber }}</span>
                                <div> <span>Ngày tạo: </span> {{ customerInfo.createdDateFormat }}</div>
                                <span class="text-xl text-primary font-bold">{{ customerInfo.fullNameUpperCase }}</span>
                                <div> <span>Điểm thưởng: </span> {{ customerInfo.points }}  </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <vs-divider/>

        <div class="vx-row">
            <div class="vx-col w-full">

                <!-- Col Header -->
                <div class="flex items-end mb-3">
                    <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-6 h-6" />
                    <span class="leading-none font-medium fsz">{{ $t('menuCustomer.contactInfo') }}</span>
                </div>
                <div class="vx-row">
                    <div class="vx-col md:w-1/4 w-full mt-4">
                        <label class="vs-input--label required">Chi nhánh</label>
                        <v-select class="w-full" v-model="selectedOrganizationBranch" :options="organizationBranchOptions"
                                  name="branch" v-validate="'required'"></v-select>
                        <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                    </div>

                    <!-- <div class="vx-col md:w-1/6 w-full mt-4">
                        <label class="vs-input--label">Mã khách hàng</label>
                        <vs-input class="w-full" v-model="customerInfo.code" name="codeCustomer" disabled />
                        <span class="text-danger text-sm">{{ errors.first('codeCustomer') }}</span>
                    </div> -->

                    <div class="vx-col md:w-1/6 w-full mt-4">
                        <label class="vs-input--label required">Họ</label>
                        <vs-input class="w-full" v-model="firstNameModel" v-validate="'required'" name="firstName" />
                        <span class="text-danger text-sm">{{ errors.first('firstName') }}</span>
                    </div>

                    <div class="vx-col md:w-1/6 w-full mt-4">
                        <label class="vs-input--label required">Tên</label>
                        <vs-input class="w-full" v-model="lastNameModel" v-validate="'required'" name="lastName" />
                        <span class="text-danger text-sm">{{ errors.first('lastName') }}</span>
                    </div>

                    <div class="vx-col md:w-1/4 w-full mt-4">
                        <label class="vs-input--label required">{{ $t('menuCustomer.customerName') }}</label>
                        <vs-input class="w-full" v-model="fullNameModel" v-validate="'required'" name="fullName" disabled />
                        <span class="text-danger text-sm">{{ errors.first('fullName') }}</span>
                    </div>

                    <div class="vx-col md:w-1/6 w-full mt-4">
                        <label class="vs-input--label required">{{ $t('menuCustomer.dayOfBirth') }}</label>
                        <!-- <datepicker :highlighted="highlighted" :disabledDates="disabledFn" :language="vi"
                            :format="'dd/MM/yyyy'" v-model="customerInfo.birthday" data-vv-validate-on="input"
                            v-validate="'required'" placeholder="Chọn ngày sinh ..." name="dayOfBirth"></datepicker> -->
                        <flat-pickr :config="configDatePicker" v-model="customerInfo.birthday"
                                    class="w-full vs-inputx vs-input--input normal" v-validate="'required'" name="dayOfBirth" />
                        <span class="text-danger text-sm">{{ errors.first('dayOfBirth') }}</span>
                    </div>

                    <div class="vx-col md:w-1/4 w-full mt-4">
                        <label class="vs-input--label required">{{ $t('menuCustomer.identityCard') }}</label>
                        <vs-input class="w-full" v-model="customerInfo.passport"
                                  v-validate="'required|numeric|min:9|max:12'" name="identityCard" />
                        <span class="text-danger text-sm">{{ errors.first('identityCard') }}</span>
                    </div>

                    <div class="vx-col md:w-1/4 w-full mt-4">
                        <label class="vs-input--label required">{{ $t('menuCustomer.phoneNumber') }}</label>
                        <vs-input class="w-full" v-model="customerInfo.phoneNumber" v-validate="'required|phone_rule|max:10|min:10|numeric'"
                                  name="phoneNumber" />
                        <span class="text-danger text-sm">{{ errors.first('phoneNumber') }}</span>
                    </div>

                    <div class="vx-col md:w-1/4 w-full mt-4">
                        <label class="vs-input--label required">Email</label>
                        <vs-input class="w-full" v-model="customerInfo.email" v-validate="'required|email'" name="email" />
                        <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                    </div>

                    <div class="vx-col md:w-1/4 w-full mt-4">
                        <label class="vs-input--label">{{ $t('menuCustomer.job') }}</label>
                        <vs-input class="w-full" v-model="customerInfo.job" name="job" />
                        <!-- <span class="text-danger text-sm">{{ errors.first('job') }}</span> -->
                    </div>

                    <!-- <div class="vx-col md:w-1/6 w-full mt-4">
                        <label class="vs-input--label">{{ $t('menuCustomer.age') }}</label>
                        <vs-input class="w-full" v-model="customerInfo.age" v-validate="'numeric'" name="age" />
                        <span class="text-danger text-sm">{{ errors.first('age') }}</span>
                    </div> -->

                    <div class="vx-col md:w-1/6 w-full mt-4">
                        <label class="vs-input--label required">{{ $t('menuCustomer.ethnic') }}</label>
                        <vs-input class="w-full" v-model="customerInfo.ethnic" name="ethnic" v-validate="'required'" />
                        <span class="text-danger text-sm">{{ errors.first('ethnic') }}</span>
                    </div>

                    <div class="vx-col md:w-1/6 w-full mt-4">
                        <label class="vs-input--label">{{ $t('menuCustomer.weight') }}</label>
                        <vs-input class="w-full" v-model="customerInfo.weight" v-validate="'numeric'" name="weight" />
                        <!-- <span class="text-danger text-sm">{{ errors.first('weight') }}</span> -->
                    </div>

                    <div class="vx-col md:w-1/6 w-full mt-4">
                        <label class="vs-input--label required">{{ $t('menuCustomer.gender') }}</label>
                        <v-select class="w-full" v-model="genderModel" :options="genderOptions" name="gender"
                                  v-validate="'required'"></v-select>
                        <span class="text-danger text-sm">{{ errors.first('gender') }}</span>
                    </div>
                </div>
            </div>
        </div>

        <vs-divider class="mt-4"/>

        <div class="vx-row">
            <!-- Col Header -->
            <div class="vx-col w-full mt-8 mb-3">
                <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-6 h-6" />
                <span class="leading-none font-medium fsz">{{ $t('menuCustomer.address') }}</span>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-2">
                <label class="vs-input--label required">Quốc gia</label>
                <v-select class="w-full" v-model="country" :clearable="false" :options="countryOptions" name="country"
                          v-validate="'required'">
                    <span slot="no-options">{{ $t('menuCustomer.noOption') }}</span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('country') }}</span>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-2">
                <label class="vs-input--label required">{{ $t('menuCustomer.city') }}</label>
                <v-select class="w-full" v-model="province" :clearable="false" :options="cityOptions" name="city"
                          v-validate="'required'">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('city') }}</span>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-2">
                <label class="vs-input--label required">{{ $t('menuCustomer.district') }}</label>
                <v-select class="" v-model="district" :clearable="false" :options="districtOptions" name="district"
                          v-validate="'required'">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('district') }}</span>
            </div>

            <div class="vx-col md:w-1/4 w-full mt-2">
                <label class="vs-input--label required">{{ $t('menuCustomer.commune') }}</label>
                <v-select class="" v-model="subDistrict" :clearable="false" :options="subDistrictOptions" name="subDistrict"
                          v-validate="'required'">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('subDistrict') }}</span>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-2">
                <label class="vs-input--label required">{{ $t('menuCustomer.houseNumber') }}</label>
                <vs-input class="w-full" v-model="customerInfo.houseNumber" name="houseNumber" v-validate="'required'" />
                <span class="text-danger text-sm">{{ errors.first('houseNumber') }}</span>
            </div>
            <div class="vx-col md:w-3/4 w-full mt-2">
                <label class="vs-input--label">{{ $t('menuCustomer.address') }}</label>
                <vs-input class="w-full" v-model="fullAddressModel" name="full_address" readonly />
            </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{
                            `${isUpdate ? $t('button.update') : $t('button.create')}`
                        }}
                    </vs-button>
                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.back()">
                        {{ $t('button.back') }}
                    </vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import VueUploadMultipleImage from '../../../components/VueUploadMultipleImage'
import province from '@/assets/utils/province.js';
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import { en, vi } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import CardCustomer from '../card-customer/card/CardCustomer.vue'
import authConfig from '@/../auth_config.json';
import country from '../../../assets/utils/country';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Vietnamese } from 'flatpickr/dist/l10n/vn'

export default {
    components: {
        VueUploadMultipleImage,
        vSelect,
        Datepicker,
        CardCustomer,
        flatPickr
    },
    data() {
        return {
            selectedOrganizationBranchValue: null,
            organizationBranchOptions: [],
            cityOptions: province.getProvince(),
            countryOptions: country.getCountry(),
            districtOptions: [],
            subDistrictOptions: [],
            isUpdate: false,
            customerInfo: {
                id: null,
                code: null,
                fullName: null,
                phoneNumber: null,
                city: null,
                district: null,
                fullAddress: null,
                houseNumber: null,
                birthday: null,
                gender: null,
                email: null,
                ethnic: null,
                job: null,
                country: null,
                firstName: null,
                lastName: null,
                organizationBranchId: null,
                passport: null,
                street: null,
                weight: null
            },
            images: [],
            user_data: null,
            imagesId: [],
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            disabledFn: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },
            en: en,
            vi: vi,
            genderOptions: [
                { value: 0, label: 'Nam' },
                { value: 1, label: 'Nữ' },
                { value: 2, label: 'Khác' },
            ],
            customerId: null,
            configDatePicker: {
                dateFormat: 'Z',
                // defaultDate: new Date(),
                locale: Vietnamese,
                maxDate: new Date(),
                altFormat: 'd/m/Y',
                altInput: true,
                wrap: true,
                allowInput: true,
            },
        }
    },
    async created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        if (branchList.length === 0) {
            return this.$vs.notify({
                text: this.$t('menuOrganization.noBranch'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        }
        this.organizationBranchOptions = branchList.filter(el => el.organizationBranchType !== 3).map(item => {
            return { value: item.id, label: item.organizationBranchName }
        });
        await this.getDataCard();
        let userInfo = localStorage.getItem("userInfo");
        this.customerInfo.organizationId = JSON.parse(userInfo).organization.id;
        // this.customerInfo.status = true

        this.customerId = this.$route.query.id;
        if (this.customerId) {
            this.isUpdate = true;
            await this.findById();
            for (const x of this.customerInfo.fileManagers) {
                let data = await this.toDataURL(x.url);
                let dataImage = data.xhr.response;
                let metadata = {
                    type: 'image/jpeg'
                };
                let file = new File([dataImage], x.fileName, metadata);
                this.images.push({
                    name: x.fileName,
                    path: data.imgBase64,
                    highlight: 1,
                    default: 1,
                    file: file
                });
            }
        }

        let imageUrl = this.$route.query.imageUrl
        if (imageUrl) {
            this.customerInfo.imageUrl = imageUrl
            let data = await this.toDataURL(this.customerInfo.imageUrl);
            let dataImage = data.xhr.response;
            let metadata = {
                type: 'image/jpeg'
            };
            let file = new File([dataImage], "avatar", metadata);
            this.images.push({
                name: "avatar",
                path: data.imgBase64,
                highlight: 1,
                default: 1,
                file: file
            });
        }
    },
    computed: {
        selectedOrganizationBranch: {
            get() {
                let object = this.organizationBranchOptions.find(el => el.value == this.customerInfo.organizationBranchId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(obj) {
                this.customerInfo.organizationBranchId = obj ? obj.value : null;
            }
        },
        validateForm() {
            return !this.errors.any()
        },
        firstNameModel: {
            get() {
                return this.customerInfo.firstName;
            },
            set(value) {
                this.customerInfo.firstName = value;
            }
        },
        lastNameModel: {
            get() {
                return this.customerInfo.lastName;
            },
            set(value) {
                this.customerInfo.lastName = value;
            }
        },
        fullNameModel: {
            get() {
                let fullName = `${this.firstNameModel ? this.firstNameModel + ' ' : ''}${this.lastNameModel ? this.lastNameModel + ' ' : ''}`;
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.customerInfo.fullName = fullName;
                return fullName;
            },
        },
        country: {
            get() {
                return {
                    label: this.getLabelString(this.countryOptions.find(x => x.label === this.customerInfo.country)),
                    value: this.customerInfo.country
                }
            },
            set(obj) {
                this.customerInfo.country = obj ? obj.label : null;
            }
        },
        province: {
            get() {
                return {
                    label: this.getLabelString(this.cityOptions.find(x => x.value === this.customerInfo.city)),
                    value: this.customerInfo.city
                }
            },
            set(obj) {
                if (obj.value) {
                    this.customerInfo.city = obj.value;
                    this.districtOptions = province.getDistrict(obj.value);
                    this.customerInfo.district = this.districtOptions[0].value;
                    this.subDistrictOptions = province.getSubDistrict(this.customerInfo.city, this.customerInfo.district);
                    this.customerInfo.street = this.subDistrictOptions[0].value;
                } else {
                    this.customerInfo.city = null;
                    this.districtOptions = [{ value: null, label: this.$t('menuCustomer.all') }];
                    this.customerInfo.district = null;
                    this.subDistrictOptions = [{ value: null, label: this.$t('menuCustomer.all') }];
                    this.customerInfo.street = null;
                }
            }
        },
        district: {
            get() {
                return {
                    label: this.getLabelString(this.districtOptions.find(x => x.value === this.customerInfo.district)),
                    value: this.customerInfo.district
                }
            },
            set(obj) {
                this.customerInfo.district = obj.value;
                this.subDistrictOptions = province.getSubDistrict(this.customerInfo.city, obj.value);
                this.customerInfo.street = this.subDistrictOptions[0].value;
            }
        },
        subDistrict: {
            get() {
                return {
                    label: this.getLabelString(this.subDistrictOptions.find(x => x.value === this.customerInfo.street)),
                    value: this.customerInfo.street
                }
            },
            set(obj) {
                this.customerInfo.street = obj.value
            }
        },
        fullAddressModel: {
            get() {
                if (this.province.value) {
                    let fullAddress = `${this.customerInfo.houseNumber ? this.customerInfo.houseNumber + ', ' : ''}${this.subDistrict.label ? this.subDistrict.label + ', ' : ''}${this.district.label}, ${this.province.label}, ${this.country.label}`;
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.customerInfo.fullAddress = fullAddress;
                    return fullAddress;
                } else {
                    return null;
                }
            },
        },
        genderModel: {
            get() {
                let object = this.genderOptions.find(el => el.value == this.customerInfo.gender);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(obj) {
                this.customerInfo.gender = obj.value;
            }
        }
    },

    watch: {
        '$store.state.isDeleteCardCustomer'(val) {
            if (val) {
                this.customerInfo.cardId = null;
                this.$store.commit('DELETE_CARD', false);
                this.getDataCard();
            }
        }
    },

    methods: {
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || this.$t('menuOrganization.null');
        },
        toDataURL(url) {
            return new Promise(resolve => {
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        resolve({ imgBase64: reader.result, xhr: xhr });
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            })
        },
        findById() {
            return new Promise((resolve, reject) => {
                this.$crm.post(`/loyalty/customer/find-by-id?id=${this.customerId}`).then((response) => {
                    this.customerInfo = response.data;
                    if (!response.data.firstName && !response.data.lastName) {
                        this.customerInfo.lastName = response.data.fullName;
                    }
                    // this.customerInfo.cardId = response.data.cardId;
                    this.customerInfo.createdDateFormat = moment(response.data.createdDate).format('DD/MM/YYYY')
                    this.customerInfo.cardNumber = response.data.card.number.toString().replace(/(.{4})/g, "$1  ");
                    this.customerInfo.points = response.data.card.points;
                    this.customerInfo.fullNameUpperCase = response.data.fullName.toString().replace(/(.{1})/g, "$1 ").toUpperCase()
                    this.countryOptions = country.getCountry(this.customerInfo.country);
                    this.districtOptions = province.getDistrict(this.customerInfo.city);
                    this.subDistrictOptions = province.getSubDistrict(this.customerInfo.city, this.customerInfo.district);
                    // this.customerInfo.urlImage = response.data.imageStore.length > 0 ? response.data.imageStore[0].url : null;
                    this.isUpdate = true;
                    // if (this.customerInfo.cardId || this.customerInfo.cardNumber) {
                    //     this.customerInfo.cardStatus = 1;
                    //     this.customerInfo.cardStaffType = 0;
                    //     this.customerInfo.customerType = this.$t('menuCustomer.customer');
                    //     this.customerInfo.cardNumber = response.data.cardStaff.cardNumber;
                    // }
                    resolve(true);
                }).catch((err) => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                    reject(false);
                });
            })
        },
        uploadImageSuccess(formData, index, fileList, file) {
            this.images = fileList;
            // this.customerInfo.urlImage = fileList.length > 0 ? fileList[0].path : null;
            this.setIsUpdateImages();
        },
        beforeRemove(index, done, fileList) {
            this.images = fileList
            this.setIsUpdateImages();
            done();
        },
        editImage(formData, index, fileList) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        dataChange(data) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        setIsUpdateImages() {
            if (this.isUpdate) {
                this.isUpdateImages = true;
            }
        },
        getLabelString(object) {
            return (object && object.label) || this.$t('menuCustomer.undefined');
        },

        manufactureString(type) {
            let typeString = this.manufactureOptions.find(x => x.value === type);
            return (typeString && typeString.label) || this.$t('menuCustomer.undefined');
        },

        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            if (this.images.length === 0) {
                return this.$vs.notify({
                    text: 'Cần phải có ít nhất 1 ảnh khách hàng!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }
            const blob = new Blob([JSON.stringify(this.customerInfo)], { type: 'application/json' });
            const formData = new FormData();
            this.images.forEach(x => formData.append('images', x.file));
            formData.append('loyaltyCustomerDTO ', blob);

            if (this.isUpdate) formData.append('id', this.customerId);


            let url = this.isUpdate ? `/loyalty/customer/update` : `/loyalty/customer/create`;
            this.$vs.loading();

            this.$crm.post(url, formData).then(() => {
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? this.$t('menuCustomer.updateCustomerSS') : this.$t('menuCustomer.addCustomerSS')}`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.$router.back();
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        handleClickUploadFile() {
            return new Promise((resolve, reject) => {
                let formData = new FormData(), config = {};
                this.images.forEach((f, i) => {
                    formData.append('files', f.file);
                });
                config = {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                };
                this.$vs.loading();
                this.$crm.post('/employee/image/upload', formData, config).then((res) => {
                    this.imagesId = [];
                    this.imagesId = res.data;
                    this.$vs.loading.close();
                    resolve(true);
                }).catch((err) => {
                    reject(true);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        chooseCard: function (card) {
            this.customerInfo.cardNumber = card.cardNumber;
            this.customerInfo.cardId = card.value;
            this.customerInfo.cardStaffType = card.cardStaffType;
            this.customerInfo.customerType = this.$t('menuCustomer.customer');
            this.customerInfo.cardId = card.value;
            this.activePopup = false;
            this.customerInfo.accessInOut = this.customerInfo.accessInOut.concat(',1')
        },
        openPopupCard: function () {
            this.activePopup = true;
        },
        getDataCard: function () {
            return new Promise((resolve, reject) => {
                let userInfo = JSON.parse(localStorage.getItem('userInfo'))
                const payload = {
                    cardStatus: 0,
                    cardStaffType: 2,
                    organizationId: userInfo.organization.id,
                    sort: 'id'
                }
                this.$vs.loading();
                this.$crm.post('/card-staff/find-by-condition', payload).then((res) => {
                    this.listCards = res.data.content.map(el => {
                        return {
                            label: el.id,
                            value: el.id,
                            cardStaffType: el.cardStaffType,
                            cardNumber: el.cardNumber
                        }
                    });
                    this.$vs.loading.close();
                    resolve();
                }).catch((err) => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
    },
}
</script>

<style scoped>
.required:after {
    content: " *";
    color: red;
}
</style>

<style lang="scss">
.membership_card_silver_rank {
    width: 328px;
    height: 178px;
    border-radius: 20px;
    background: linear-gradient(to bottom right, #f9f295, #e0aa3e, #f7ef8a, #b88a44);
}

.membership_card_gold_rank {
    width: 328px;
    height: 178px;
    border-radius: 20px;
    background: linear-gradient(to bottom right, #f9f295, #e0aa3e, #f7ef8a, #b88a44);
}

.membership_card_platinum_rank {
    width: 328px;
    height: 178px;
    border-radius: 20px;
    background: radial-gradient(circle at 14% 75%, #D3D3D3, #A9A9A9);
}
</style>
